// Confirmación de email para las cuentas que entran con email y clave.
//
// El acceso a un estacionamiento se da por email (lo autoriza el dueño desde
// TicketControl). Sin confirmar que el email es de quien se registra,
// cualquiera que conozca un email autorizado podía crearle una cuenta con una
// clave propia. Quien entra con Google no pasa por acá: Google ya lo verificó.

// Sólo se exige a las cuentas creadas desde esta fecha. Las anteriores quedan
// eximidas: son clientes que entran todos los días y nunca confirmaron nada;
// pedírselo de golpe los dejaría afuera.
export const VERIFY_EMAIL_SINCE = Date.parse("2026-10-05T00:00:00Z");

/**
 * @param {*} user usuario de Firebase Auth (firebase.auth().currentUser)
 * Ante cualquier dato que falte devuelve false: esto no puede dejar afuera a
 * un cliente por un error nuestro.
 */
export const needsEmailVerification = (user) => {
  if (!user || user.emailVerified) return false;
  const providers = (user.providerData || []).map((p) => p && p.providerId);
  if (!providers.includes("password") || providers.includes("google.com")) return false;
  const created = Date.parse(user.metadata?.creationTime || "");
  return Number.isFinite(created) && created >= VERIFY_EMAIL_SINCE;
};

// A dónde lleva el botón "Continuar" de la página de Firebase que confirma el email.
export const verificationSettings = () => ({
  url: window.location.protocol + "//" + window.location.host + "/dashboard",
});

/**
 * Envía el email de confirmación. `send(settings)` es la llamada a Firebase.
 * Si Firebase rechaza la dirección de retorno (el dominio no está entre los
 * autorizados del proyecto), lo envía igual sin el botón "Continuar": que un
 * ajuste de la consola no deje a las cuentas nuevas sin poder confirmar.
 */
export const sendVerification = async (send) => {
  try {
    await send(verificationSettings());
  } catch (error) {
    if (!/continue-uri/.test(error?.code || "")) throw error;
    await send();
  }
};

// Cuándo se le envió el email a esta cuenta desde este navegador: evita
// reenviarlo en cada recarga y permite frenar los pedidos seguidos.
const sentKey = (uid) => `monitorVerifyEmailSent:${uid}`;

export const verificationSentAt = (uid) => {
  try {
    return Number(localStorage.getItem(sentKey(uid))) || 0;
  } catch (e) {
    return 0;
  }
};

export const markVerificationSent = (uid) => {
  try {
    localStorage.setItem(sentKey(uid), String(Date.now()));
  } catch (e) {
    // Sin localStorage sólo se pierde el freno a los reenvíos.
  }
};
